import { component } from 'picoapp'

class HeroVideo {

  constructor(node, ctx) {
    // bindings
    this.toggleVolume = this.toggleVolume.bind(this)

    // Selectors
    this._node = node;
    this._video = this._node.querySelector('video')
    this._vol_btn = this._node.querySelector('#vol-btn')

    // Event listeners
    this._vol_btn.addEventListener('click', this.toggleVolume, false)

    this._video.load()

    this.unmount.bind(this)
  }

  //
  // Handle menu btn click.
  //
  toggleVolume() {
    if (this._vol_btn.classList.contains('muted')) {
      this._vol_btn.classList.remove('muted')
      this._video.muted = false
    } else {
      this._vol_btn.classList.add('muted')
      this._video.muted = true
    }
  }

  //
  // Unmount.
  //
  unmount() {
    this._vol_btn.removeEventListener('click', this.toggleVolume, false)
  }
}

export default component((node, ctx) => new HeroVideo(node, ctx))
